<template lang="html">
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col
                cols="3"
                class="pb-0"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in name here"
                  append-icon="fas fa-search"
                  label="Search"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-spacer />
              <v-col
                cols="2"
                class="pb-0"
              >
                <file-manager-dialog-create
                  v-if="$hasPermissionTo(['create folders'])"
                  :parent-id="navItems[navItems.length-1].id"
                  @created="reloadForms"
                />
              </v-col>

              <v-col
                cols="2"
                class="pb-0"
              >
                <file-manager-dialog-upload
                  v-if="$hasPermissionTo(['upload files'])"
                  :parent-id="navItems[navItems.length-1].id"
                  @uploaded="reloadForms"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-breadcrumbs
            :items="navItems" 
            divider="/"
          >
            <template v-slot:item="props">
              <a
                @click="loadFormsBackward(props.item)"
              >{{ props.item.text }}</a>
            </template> 
          </v-breadcrumbs>

          <v-row
            v-if="loading"
            class="mx-2"
          >
            <v-col
              v-for="(document,i) in Math.floor((Math.random() * 10) + 2)"
              :key="i"
              cols="2"
            >
              <v-skeleton-loader
                type="image"
                height="118"
              />
            </v-col>
          </v-row>

          <v-row
            v-else
            class="mx-2"
          >
            <v-col
              v-for="(document,i) in filteredDocuments"
              :key="i"
              cols="2"
            >
              <v-card
                v-if="['pdf'].includes(document.name.split('.').pop())"
                elevation-5 
                class="text-center"
                max-width="370"
              >
                <div
                  class="pb-4 clickable"
                  @click="openNewTab(document)"
                >
                  <v-icon
                    class="pt-6"
                    color="red"
                    x-large
                  >
                    mdi-file-pdf
                  </v-icon>
                </div>

                <v-hover v-slot:default="{ hover }">
                  <div class="pb-4">
                    <span class="font-weight-bold pt-0">                   
                      {{ document.name }}
                    </span>
                   
                    <span v-show="hover">
                      <file-manager-dialog-delete
                        v-if="$hasPermissionTo(['create folders'])"
                        :document="document"
                        :parent-id="navItems[navItems.length-1].id"
                        @deleted="reloadForms"
                      />
                    </span>
                  </div>
                </v-hover>  
              </v-card>

              <v-card
                v-else-if="['docx','doc'].includes(document.name.split('.').pop())"
                elevation-5 
                class="text-center"
                max-width="370"
              >
                <div
                  class="pb-4 clickable"
                  @click="openNewTab(document)"
                >
                  <v-icon
                    class="pt-6"
                    color="blue"
                    x-large
                  >
                    mdi-file-document
                  </v-icon>
                </div>

                <v-hover v-slot:default="{ hover }">
                  <div class="pb-4">
                    <span class="font-weight-bold pt-0">                   
                      {{ document.name }}
                    </span>
                   
                    <span v-show="hover">
                      <file-manager-dialog-delete
                        v-if="$hasPermissionTo(['create folders'])"
                        :document="document"
                        :parent-id="navItems[navItems.length-1].id"
                        @deleted="reloadForms"
                      />
                    </span>
                  </div>
                </v-hover>
              </v-card>

              <v-card
                v-else-if="['xls','xlsx','csv'].includes(document.name.split('.').pop())"
                elevation-5 
                class="text-center"
                max-width="370"
              >
                <div
                  class="pb-4 clickable"
                  @click="openNewTab(document)"
                >
                  <v-icon
                    class="pt-6"
                    color="green"
                    x-large
                  >
                    mdi-file-excel
                  </v-icon>
                </div>

                <v-hover v-slot:default="{ hover }">
                  <div class="pb-4">
                    <span class="font-weight-bold pt-0">                   
                      {{ document.name }}
                    </span>
                   
                    <span v-show="hover">
                      <file-manager-dialog-delete
                        v-if="$hasPermissionTo(['create folders'])"
                        :document="document"
                        :parent-id="navItems[navItems.length-1].id"
                        @deleted="reloadForms"
                      />
                    </span>
                  </div>
                </v-hover>
              </v-card>

              <v-card
                v-else
                elevation-5 
                class="text-center"
                max-width="370"
              >
                <div
                  class="pb-4 clickable"
                  @click="loadFormsForward(document)"
                >
                  <v-icon
                    class="pt-6"
                    color="teal"
                    x-large
                  >
                    far fa-folder
                  </v-icon>
                </div>

                <v-hover v-slot:default="{ hover }">
                  <div class="pb-4">
                    <span class="font-weight-bold pt-0">                   
                      {{ document.name }}
                    </span>
                   
                    <span v-show="hover">
                      <file-manager-dialog-edit
                        v-if="$hasPermissionTo(['rename folders'])"
                        :document="document"
                        @updated="reloadForms"
                      />

                      <file-manager-dialog-delete
                        v-if="$hasPermissionTo(['create folders'])"
                        :document="document"
                        :parent-id="navItems[navItems.length-1].id"
                        @deleted="reloadForms"
                      />
                    </span>
                  </div>
                </v-hover>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

  export default {
    components: {
      // FileManagerDialogCreate: () => import('@/components/file-manager/DialogCreate'),
      FileManagerDialogEdit: () => import('@/components/file-manager/DialogEdit'),
      FileManagerDialogUpload: () => import('@/components/file-manager/DialogUpload'),
      FileManagerDialogDelete: () => import('@/components/file-manager/DialogDelete'),
    },

    data () {
      return {
        documents: [],
        search: null,
        navItems: [
          {
            id: 0,
            text: 'Home',
            increment: 1,
          },
        ],
        loading: false,
      }
    },

    computed: {
      filteredDocuments () {
        if (!this.search) return this.documents

        return this.documents.filter(document => {
          return document.name.includes(this.search)
        })
      },
    },

    created () {
      this.loadForms({ id: 0 })
    },
    methods: {
      loadFormsForward (document) {
        if (document.id !== 0) {
          let exists = this.navItems.some(item => {
            return item.id === document.id 
          })
          
          if (!exists) {
            this.navItems.push({ id: document.id, text: document.name, increment: this.navItems.length + 1 }) 
          }
        }

        this.loadForms(document.id)
      },

      loadFormsBackward (document) {
        this.navItems = this.navItems.filter(navItem => {
          return navItem.increment <= document.increment
        })

        this.loadForms(document.id)
      },

      loadForms (id) {
        this.loading = true

        this.$api.documents().list(id)
          .then(res => {
            this.documents = _.orderBy(res.data, [file => file.file_path === null, file => file.name.toLowerCase()], ['desc', 'asc'])

            this.loading = false
          })
      },

      reloadForms (data) {
        this.loadForms(data.parent)
      },

      openNewTab (document) {
        window.open(document.file_url)
      }, 
    },
  }
</script>

<style scoped>
.clickable{
  cursor:pointer
}
</style>
